export default "__VITE_ASSET__CyFaCQ$O__"